import moment from 'moment'

export default {
  computed: {
    endorsementExists () {
      return this.endorsement.id !== null
    },

    endorsementDoesNotExist () {
      return this.endorsement.id === null
    },

    endorsementDateEndorsed () {
      return moment(this.endorsement.date_endorsed).format('DD/MM/YYYY')
    }
  }
}
